import { supabase } from '../../supabaseClient';

export function insertTenderQuoteTask(dealId, n, session) {
  return supabase.from('affaire_activites').insert({
    affaire_id: dealId,
    nature: 'action',
    type: 'Envoyer le chiffrage',
    etat: 'prevu',
    date: n.date_limite.slice(0, 10),
    auteur_id: session.user.id,
  });
}

export function insertDealActivity(dealModal, f, session) {
  return supabase.from('affaire_activites').insert({
    affaire_id: dealModal.id,
    nature: 'action',
    type: f.type,
    etat: f.etat,
    date: f.date || null,
    note: f.note || null,
    auteur_id: session.user.id,
  });
}

export function insertQuickTask(session, t) {
  return supabase.from('affaire_activites').insert({
    affaire_id: t.affaire_id,
    nature: 'action',
    type: t.type,
    etat: 'prevu',
    date: t.date || null,
    note: t.note || null,
    auteur_id: session.user.id,
  });
}
